module.exports = __webpack_public_path__ + "static/media/022.3a067415.jpg";